import Close from '@mui/icons-material/Close';
import Backdrop from '@mui/material/Backdrop';
import MuiTooltip from '@mui/material/Tooltip';
import { clsx } from 'clsx';
import { FC, memo } from 'react';
import { TooltipContentProps, TooltipProps } from './types';
import styles from './styles/styles.module.css';

const TooltipContent = memo(
  ({ handleTooltipClose, children }: TooltipContentProps) => {
    return (
      <div className={styles.tooltipContent} data-testid="tooltipContent">
        <div
          onClick={handleTooltipClose}
          className={styles.closeBtn}
          data-testid="tooltipCloseButton"
        >
          <Close />
        </div>
        {children}
      </div>
    );
  },
);

/** @todo 1.) do styles simplifier*/
/** @todo 2.) remove extra folders*/
/** @todo 3.) rebuild component easier*/
/** @todo 4.) change icon to icomoon (remove icons-material)*/
export const Tooltip: FC<TooltipProps> = ({
  className,
  rootClassName,
  arrowClassName,
  ...props
}) => {
  return (
    <>
      <Backdrop
        open={!!props.open}
        className={clsx(styles.backdrop, {
          [styles.backdropOpen]: !!props.open,
        })}
        onClick={props.onClose}
      />
      <MuiTooltip
        PopperProps={{
          disablePortal: true,
        }}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        arrow
        {...props}
        classes={{
          tooltip: clsx(styles.root, rootClassName, className),
          arrow: clsx(styles.arrow, arrowClassName),
          popper: styles.popper,
        }}
        title={
          <TooltipContent handleTooltipClose={props.onClose}>
            {props.element}
          </TooltipContent>
        }
        data-testid="tooltip"
      />
    </>
  );
};
